const ko = {
  // Navbar
  nav_home: "홈",
  nav_about: "텐텐 아저씨 소개",
  nav_services: "서비스 및 요금",
  nav_flow: "서비스 흐름",
  nav_testimonials: "이용 후기",
  nav_faq: "자주 묻는 질문",
  nav_contact: "문의하기",
  nav_cta: "이름 감정 예약",
  nav_subtitle: "이름 감정 · 오키나와",
  nav_title: "텐텐 아저씨 감정소",

  // Hero
  hero_headline1: "고요한",
  hero_headline2: "오키나와 섬에서",
  hero_headline3: "당신의",
  hero_headline4: "이름의 소리를 듣다.",
  hero_body: "수개월 대기가 이어지는 인기 이름 감정 예약.\n매달 직접 오키나와 섬을 방문하여\n선생님께 당신의 이름을 전달합니다.",
  hero_pill1: "개명 불필요",
  hero_pill2: "100% 온라인",
  hero_pill3: "1개월 이내 전달",
  hero_pill4: "매월 선착순 100명",
  hero_btn_apply: "이름 감정 예약하기",
  hero_btn_services: "서비스 보기",
  hero_scroll: "아래로 스크롤",

  // About
  about_heading: "텐텐 아저씨 소개",
  about_intro: "오키나와의 따뜻한 바다에 둘러싸인 조용한 섬 <strong>이케이지마</strong>에,\n각각의 이름에 작은 빛을 더해주는 사람이 살고 있습니다.\n사람들은 그를 친근하게 <strong>「텐텐 아저씨」</strong>라고 부릅니다.",
  about_block1_label: "은행원에서 이름 감정사로",
  about_block1_text: "텐텐 아저씨는 원래 은행원이었습니다.\n성실한 노력으로 회사에서 <strong>최연소 지점장</strong>이 되었습니다.\n많은 사람들을 만나면서 마음속에 한 가지 의문이 생겼습니다.",
  about_block1_quote: "「같은 노력을 해도 왜 어떤 사람은 순풍을 타는 것처럼 보일까?」",
  about_block1_sub: "이 작은 의문이 위대한 탐구 여정의 시작이 되었습니다.",
  about_block2_label: "고대의 지혜와 고요한 깨달음",
  about_block2_text: "모든 여가 시간을 고대 이름 감정 전적 연구에 쏟으며, 전통 한자의 획수와 음운의 흐름을 세심하게 탐구했습니다.",
  about_block2_text2: "그는 <strong>「탁점(てんてん)이 이름의 흐름을 조용히 조화롭게 할 수 있다」</strong>는 것을 깨달았습니다.",
  about_block2_sub: "이것은 극적인 마법도, 화려한 성공 공식도 아닙니다.\n이미 내면에 있는 빛을 더욱 선명하게 드러내는 부드러운 길입니다.",
  about_block3_label: "입소문으로 퍼져 — 지금은 6개월 대기",
  about_block3_text: "그의 따뜻한 감정은 완전히 입소문으로만 퍼져, 지금은 <strong>전국에서 상담이 끊이지 않습니다</strong>.\n유명인이든 아니든 모든 사람을 같은 마음으로 대합니다.\n각각의 이름에 손을 얹고, 그 사람의 인생을 함께합니다.\n이것이 텐텐 아저씨의 방식입니다.",

  // Gallery
  gallery_heading: "갤러리",
  gallery_sub: "오키나와 · 이케이지마",

  // Services
  services_heading: "서비스 및 요금",
  services_note1: "※ 모든 플랜에는 선생님 감정료 및 저희 현지 대행 서비스료가 포함되어 있습니다.",
  services_note2: "※ 추가 비용은 없습니다. 안심하고 맡겨주세요.",
  services_tab1: "개인 이름",
  services_tab2: "상호명",
  services_tab3: "반려동물 이름",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "성장 과정, 환경, 마음의 움직임을 부드럽게 살펴 가장 적합한 탁점을 더해드립니다.",
  services_tab2_desc: "새로운 도전에 부드러운 순풍을 불어넣습니다. 사업의 흐름을 조용히 조화롭게 합니다.",
  services_tab3_desc: "항상 곁에 있는 가족을 위해. 평온함과 따뜻함이 가득한 이름을 드립니다.",
  services_row1_target1: "16세 이상",
  services_row1_target2: "4~15세",
  services_row1_target3: "0~3세",
  services_row2_target1: "상호 / 회사 / 가게 이름",
  services_row3_target1: "반려동물 이름",
  services_col_target: "대상",
  services_col_price: "요금 (세금 포함)",
  services_cta: "이 서비스 예약하기",
  services_includes_title: "포함 내용 (모두 요금에 포함)",
  services_inc1: "이름 감정",
  services_inc2: "최적의 탁점 제안",
  services_inc3: "명함 크기 카드 우편 발송 (무료, 희망 시)",
  services_inc4: "개운 조언",
  services_inc5: "이름 카드 디지털 사진",
  services_includes_note: "감정은 이름에 이미 있는 매력을 부드럽게 드러내는 것을 목적으로 합니다.",
  services_payment_title: "결제 방법",
  services_payment_method: "은행 이체 (선불)",
  services_payment_desc: "신청 후 계좌 정보를 안내해 드립니다.\n결제가 완료되면 행운의 흐름이 조용히 모이기 시작합니다.",
  services_first_title: "처음 방문하시는 분께",
  services_first_desc: "불안한 것은 당연합니다.\n그 느낌은 내면의 신호,\n부드러운 변화를 시작할 때가 되었다는 것입니다.",
  services_first_cta: "상담부터 시작하기",

  // Flow
  flow_heading: "서비스 흐름",
  flow_step1_title: "신청서 제출",
  flow_step1_c1: "전용 양식에 필요한 정보를 입력해 주세요.",
  flow_step1_c2: "제출 후 2~3 영업일 이내에 답변 드립니다.",
  flow_step1_c3: "이메일에 다음 단계 및 은행 이체 안내가 포함됩니다.",
  flow_step2_title: "감정료 이체",
  flow_step2_c1: "답변 이메일에 안내된 계좌로 감정료를 이체해 주세요.",
  flow_step2_c2: "입금 확인 후 순서대로 감정 준비를 시작합니다.",
  flow_step3_title: "이체 완료 알림",
  flow_step3_c1: "이체 후 영수증 사진을 이메일에 안내된 주소로 보내주세요.",
  flow_step3_c2: "확인 후 「등록 완료」 메시지를 보내드립니다.",
  flow_step3_note: "이 알림을 받지 못하면 감정을 시작할 수 없습니다. 반드시 보내주세요.",
  flow_step4_title: "감정 결과 수령",
  flow_step4_c1: "감정 완료 후 약 1주일 이내에 이름 카드 및 탁점 사진을 이메일로 보내드립니다.",
  flow_step4_c2: "이후 상세 감정 보고서와 개운 조언을 이메일로 보내드립니다.",
  flow_step5_title: "이름 카드 발송 (선택)",
  flow_step5_c1: "희망 시 선생님이 직접 쓴 명함 크기 카드를 우편으로 발송합니다.",
  flow_step5_c2: "신청서의 주소란에 정확한 우편 주소를 입력해 주세요.",
  flow_step5_note: "카드가 필요 없으신 경우 거주 도시만 입력하셔도 됩니다.",
  flow_banner_title: "전부 온라인. 일본 어디서든.",
  flow_banner_desc: "오키나와 이케이지마에 직접 오실 필요가 없습니다.\n일상을 바꾸지 않고 바로 시작할 수 있습니다.",
  flow_banner_cta: "지금 신청하기",

  // Testimonials
  testimonials_heading: "이용 후기",
  testimonials_viewing: "보는 중",

  // FAQ
  faq_heading: "자주 묻는 질문",
  faq_cta_title: "다른 질문이 있으신가요?",
  faq_cta_desc: "어떤 작은 질문이라도 환영합니다.\n말하기 부끄러운 질문 — 그것이 저희가 가장 듣고 싶은 것입니다.",
  faq_cta_btn: "질문하기",

  // CTA Banner
  cta_heading1: "무료",
  cta_heading2: "상담",
  cta_btn: "지금 예약하기",

  // Contact
  contact_heading: "문의하기",
  contact_desc: "이 양식을 통해 감정 신청 또는 문의를 보내주세요. 보통 2~3 영업일 이내에 답변 드립니다.",
  contact_address_label: "주소",
  contact_address_value: "일본 도치기현 (온라인 · 전국 대응)",
  contact_email_label: "이메일",
  contact_hours_label: "영업 시간",
  contact_hours_value: "월~금 9:00–18:00 (토/일/공휴일 휴무)",
  contact_note_title: "답변에 대하여",
  contact_note_desc: "답변이 스팸 폴더에 들어갈 수 있습니다.\n2~3 영업일 이내에 답변을 받지 못하신 경우 이메일로 직접 연락해 주세요.",
  contact_field_name: "이름",
  contact_field_furigana: "후리가나 (읽는 법)",
  contact_field_email: "이메일 주소",
  contact_field_phone: "전화번호",
  contact_field_service: "희망 서비스",
  contact_field_message: "메시지",
  contact_placeholder_name: "홍길동",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+82 000 0000 0000",
  contact_placeholder_message: "감정을 원하시는 이름이나 질문 및 요청 사항을 입력해 주세요.",
  contact_select_placeholder: "선택해 주세요",
  contact_service1: "개인 이름",
  contact_service2: "상호명",
  contact_service3: "반려동물 이름",
  contact_service4: "기타 / 상담",
  contact_submit: "제출",
  contact_submitting: "제출 중...",
  contact_privacy: "양식을 통해 제출된 개인 정보는 이름 감정 서비스에만 사용됩니다.",
  contact_error: "제출에 실패했습니다. 잠시 후 다시 시도하시거나 이메일로 직접 연락해 주세요.",
  contact_err_name: "이름을 입력해 주세요",
  contact_err_email_required: "이메일 주소를 입력해 주세요",
  contact_err_email_invalid: "유효한 이메일 주소를 입력해 주세요",
  contact_err_service: "서비스를 선택해 주세요",
  contact_err_message_required: "메시지를 입력해 주세요",
  contact_err_message_limit: "메시지는 500자 이내로 입력해 주세요",
  contact_thanks_title: "메시지가 전송되었습니다",
  contact_thanks_desc: "연락해 주셔서 감사합니다.\n메시지를 확인한 후 <strong>2~3 영업일</strong> 이내에 답변 드리겠습니다.\n잠시 기다려 주세요.",
  contact_thanks_check1: "확인 이메일을 확인해 주세요",
  contact_thanks_check2: "스팸 폴더도 확인해 주세요",
  contact_thanks_check3: "2~3 영업일 이내 답변을 기다려 주세요",
  contact_thanks_another: "다시 메시지 보내기",

  // Footer
  footer_subtitle: "이름 감정 · 오키나와",
  footer_title: "텐텐 아저씨 감정소",
  footer_desc: "오키나와에서 전국으로. 50년 이상의 경험을 가진 이름 감정 선생님이 당신의 이름에 담긴 운명을 정성껏 읽어드립니다.",
  footer_contact_title: "연락처 정보",
  footer_address_label: "주소",
  footer_address_value: "일본 도치기현\n(온라인 · 전국 대응)",
  footer_email_label: "이메일",
  footer_hours_label: "영업 시간",
  footer_hours_value: "월~금 9:00–18:00\n(토/일/공휴일 휴무)",
  footer_nav_title: "내비게이션",
  footer_copyright: "© 2025 텐텐 아저씨 감정소 All Rights Reserved.",
  footer_privacy: "개인정보 처리방침",
  footer_law: "특정상거래법",
  footer_sitemap: "사이트맵",
};

export default ko;
